<template>
  <v-radio-group v-model="paymentOption" :mandatory="false">
    <div
      style="min-height: 76px; max-height: 76px;"
      class="radio-option pt-0"
      @click="paymentOption = option.id"
      :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
    >
      <div class="radio-option__info" style="min-height: 77px; max-height: 77px; min-width: 200px;">
        <div class="radio-option__info-text px-0" style="width: 100%;">
        <v-layout>
          <label :for="option.id">{{ option.label }}</label>
          <v-img max-height="24" max-width="91" class="ml-2" flat src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/ame_logo.svg"></v-img>
        </v-layout>
        <v-layout>
          <h4 class="checkout-h4 green--text">{{option.info}}</h4>
        </v-layout>
        </div>
      </div>
      <v-radio color="primary" :id="option.id" :value="option.id"></v-radio>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  data() {
    return {
      option: {
        id: 'AME',
        label: 'Pagar com',
        info: '',
      },
    };
  },
  computed: {
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },
  },
  methods: {
    selectAme () {
      this.$store.commit('SET_SECOND_PAYMENT_STEP', true)
      this.$store.commit('SET_AME_SELECTED', true)
      this.$store.dispatch('chargeAme')
    },
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentBillet.styl';
</style>
